import React, { useState } from 'react';
import { 
  Row, Col, Card, Tabs, Form, Input, Button, Select, Upload, 
  List, Tag, Badge, Steps, Divider, Rate, Typography, Space, Avatar 
} from 'antd';
import {
  UploadOutlined, SearchOutlined, FilterOutlined, 
  CheckCircleOutlined, ClockCircleOutlined, ExclamationCircleOutlined,
  SolutionOutlined, RobotOutlined, FileTextOutlined, BulbOutlined
} from '@ant-design/icons';
import './index.css';

const { TabPane } = Tabs;
const { Option } = Select;
const { TextArea } = Input;
const { Step } = Steps;
const { Title, Paragraph, Text } = Typography;

// 模拟数据
const mockTickets = [
  {
    id: '2023102501',
    title: '企业项目审批流程咨询',
    type: '咨询服务',
    status: 'processing',
    priority: 'normal',
    createTime: '2023-10-25 09:23:45',
    updateTime: '2023-10-25 10:15:30',
    department: '行政审批局',
    description: '我公司计划投资新建一个智能制造项目，想咨询相关审批流程和所需材料。',
  },
  {
    id: '2023102401',
    title: '营业执照变更申请异常',
    type: '问题反馈',
    status: 'done',
    priority: 'high',
    createTime: '2023-10-24 14:35:22',
    updateTime: '2023-10-25 08:42:15',
    department: '市场监管局',
    description: '在线申请营业执照变更时系统提示异常，无法提交材料，急需处理。',
  },
  {
    id: '2023102301',
    title: '小微企业融资补贴申请',
    type: '政策咨询',
    status: 'pending',
    priority: 'normal',
    createTime: '2023-10-23 11:42:17',
    updateTime: '2023-10-23 11:42:17',
    department: '财政局',
    description: '了解到有小微企业融资贴息政策，想咨询我司是否符合条件以及如何申请。',
  },
  {
    id: '2023102201',
    title: '外商投资企业设立流程',
    type: '咨询服务',
    status: 'processing',
    priority: 'high',
    createTime: '2023-10-22 15:37:28',
    updateTime: '2023-10-23 09:12:50',
    department: '商务局',
    description: '我是一家外国企业，想在贵市设立分公司，需要了解详细的设立流程和所需材料。',
  },
  {
    id: '2023102101',
    title: '环保设备税收减免政策咨询',
    type: '政策咨询',
    status: 'done',
    priority: 'normal',
    createTime: '2023-10-21 10:08:36',
    updateTime: '2023-10-22 14:23:45',
    department: '税务局',
    description: '我司新购置了一批环保设备，听说有相关税收减免政策，想咨询具体细则。',
  },
];

const mockPolicies = [
  {
    id: 1,
    title: '小微企业融资担保费用补贴政策',
    department: '财政局',
    publishDate: '2023-09-15',
    category: '融资支持',
    tags: ['小微企业', '融资担保', '费用补贴'],
    abstract: '对符合条件的小微企业获得融资担保服务的，按担保费用的50%给予补贴，每家企业年度最高补贴不超过50万元。',
    match: 98,
  },
  {
    id: 2,
    title: '高新技术企业研发费用加计扣除',
    department: '税务局',
    publishDate: '2023-08-21',
    category: '税收优惠',
    tags: ['高新技术', '研发费用', '税收扣除'],
    abstract: '对符合条件的高新技术企业，研发费用可按实际发生额的75%在税前加计扣除；形成无形资产的，按无形资产成本的175%在税前摊销。',
    match: 85,
  },
  {
    id: 3,
    title: '企业数字化转型专项补贴',
    department: '工信局',
    publishDate: '2023-10-10',
    category: '数字经济',
    tags: ['数字化转型', '智能制造', '补贴'],
    abstract: '支持企业数字化、网络化、智能化改造，对符合条件的企业按照项目投资额的30%给予补贴，最高不超过200万元。',
    match: 76,
  },
  {
    id: 4,
    title: '创业孵化基地房租减免政策',
    department: '科技局',
    publishDate: '2023-07-05',
    category: '创业扶持',
    tags: ['创业孵化', '房租减免', '初创企业'],
    abstract: '对入驻市级认定的创业孵化基地的初创企业，前两年房租全免，第三年减半。',
    match: 65,
  },
  {
    id: 5,
    title: '外贸企业出口信保费补贴',
    department: '商务局',
    publishDate: '2023-09-28',
    category: '外贸支持',
    tags: ['外贸企业', '出口信保', '保费补贴'],
    abstract: '对外贸企业投保短期出口信用保险的，按照实际缴纳保费的50%给予补贴，年度最高不超过100万元。',
    match: 42,
  },
];

const BusinessServiceHall = () => {
  const [activeTab, setActiveTab] = useState('submit');
  const [selectedTicket, setSelectedTicket] = useState(null);
  const [form] = Form.useForm();
  
  // 处理表单提交
  const handleSubmit = (values) => {
    console.log('表单提交:', values);
    // 实际应用中这里会发送请求到后端
    form.resetFields();
    setActiveTab('manage');
  };
  
  // 获取工单状态标签
  const getStatusTag = (status) => {
    switch(status) {
      case 'pending':
        return <Tag icon={<ClockCircleOutlined />} color="default">待受理</Tag>;
      case 'processing':
        return <Tag icon={<SolutionOutlined spin />} color="processing">处理中</Tag>;
      case 'done':
        return <Tag icon={<CheckCircleOutlined />} color="success">已办结</Tag>;
      default:
        return <Tag color="default">{status}</Tag>;
    }
  };
  
  // 获取优先级标签
  const getPriorityTag = (priority) => {
    switch(priority) {
      case 'high':
        return <Tag color="error">紧急</Tag>;
      case 'normal':
        return <Tag color="blue">普通</Tag>;
      case 'low':
        return <Tag color="green">低</Tag>;
      default:
        return <Tag color="blue">{priority}</Tag>;
    }
  };
  
  // 渲染工单详情
  const renderTicketDetail = () => {
    if (!selectedTicket) {
      return (
        <div className="empty-detail">
          <SolutionOutlined />
          <p>请选择左侧工单查看详情</p>
        </div>
      );
    }
    
    const ticketSteps = [
      {
        title: '提交工单',
        description: `${selectedTicket.createTime}`,
        status: 'finish',
      },
      {
        title: '受理工单',
        description: selectedTicket.status === 'pending' ? '等待受理' : '2023-10-25 10:00:00',
        status: selectedTicket.status === 'pending' ? 'wait' : 'finish',
      },
      {
        title: '处理中',
        description: selectedTicket.status === 'processing' ? '正在处理' : 
                     selectedTicket.status === 'pending' ? '' : '2023-10-25 14:30:00',
        status: selectedTicket.status === 'pending' ? 'wait' : 
                selectedTicket.status === 'processing' ? 'process' : 'finish',
      },
      {
        title: '工单完成',
        description: selectedTicket.status === 'done' ? selectedTicket.updateTime : '',
        status: selectedTicket.status === 'done' ? 'finish' : 'wait',
      },
    ];
    
    return (
      <div className="ticket-detail">
        <div className="ticket-header">
          <div className="ticket-title">
            <h2>{selectedTicket.title}</h2>
            <div className="ticket-tags">
              {getPriorityTag(selectedTicket.priority)}
              <Tag>{selectedTicket.type}</Tag>
            </div>
          </div>
          <div className="ticket-status">
            {getStatusTag(selectedTicket.status)}
            <div className="ticket-id">工单号: {selectedTicket.id}</div>
          </div>
        </div>
        
        <Divider />
        
        <div className="ticket-info">
          <div className="info-item">
            <span className="info-label">提交时间:</span>
            <span className="info-value">{selectedTicket.createTime}</span>
          </div>
          <div className="info-item">
            <span className="info-label">处理部门:</span>
            <span className="info-value">{selectedTicket.department}</span>
          </div>
          <div className="info-item">
            <span className="info-label">最后更新:</span>
            <span className="info-value">{selectedTicket.updateTime}</span>
          </div>
        </div>
        
        <div className="ticket-description">
          <h3>问题描述</h3>
          <p>{selectedTicket.description}</p>
        </div>
        
        <div className="ticket-process">
          <h3>处理进度</h3>
          <Steps current={selectedTicket.status === 'pending' ? 0 : 
                           selectedTicket.status === 'processing' ? 2 : 3}
                 className="ticket-steps">
            {ticketSteps.map((step, index) => (
              <Step key={index} title={step.title} description={step.description} status={step.status} />
            ))}
          </Steps>
        </div>
        
        {selectedTicket.status === 'done' && (
          <div className="ticket-feedback">
            <h3>服务评价</h3>
            <div className="feedback-form">
              <div className="rating-item">
                <span className="rating-label">服务态度:</span>
                <Rate disabled defaultValue={5} />
              </div>
              <div className="rating-item">
                <span className="rating-label">处理效率:</span>
                <Rate disabled defaultValue={4} />
              </div>
              <div className="rating-item">
                <span className="rating-label">解决程度:</span>
                <Rate disabled defaultValue={5} />
              </div>
              <div className="feedback-comment">
                <p>问题得到了很好的解决，工作人员态度专业，解答详细，非常满意！</p>
              </div>
            </div>
          </div>
        )}
        
        {selectedTicket.status !== 'done' && (
          <div className="ticket-actions">
            <Button type="primary">催办</Button>
            <Button>补充信息</Button>
            {selectedTicket.status === 'processing' && <Button type="dashed">撤销工单</Button>}
          </div>
        )}
      </div>
    );
  };
  
  return (
    <div className="service-container">
      <div className="service-header">
        <h1>企业服务大厅</h1>
      </div>
      
      <Row gutter={[16, 16]}>
        <Col xs={24} md={16}>
          <Card className="service-card">
            <Tabs activeKey={activeTab} onChange={setActiveTab}>
              <TabPane tab="诉求提交" key="submit">
                <div className="submit-form">
                  <Form 
                    form={form}
                    layout="vertical"
                    onFinish={handleSubmit}
                    requiredMark="optional"
                  >
                    <Form.Item 
                      name="title" 
                      label="标题" 
                      rules={[{ required: true, message: '请输入标题' }]}
                    >
                      <Input placeholder="请简要描述您的问题" maxLength={50} />
                    </Form.Item>
                    
                    <Row gutter={16}>
                      <Col xs={24} sm={12}>
                        <Form.Item 
                          name="type" 
                          label="类型" 
                          rules={[{ required: true, message: '请选择类型' }]}
                        >
                          <Select placeholder="请选择问题类型">
                            <Option value="咨询服务">咨询服务</Option>
                            <Option value="问题反馈">问题反馈</Option>
                            <Option value="政策咨询">政策咨询</Option>
                            <Option value="建议投诉">建议投诉</Option>
                            <Option value="其他">其他</Option>
                          </Select>
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={12}>
                        <Form.Item 
                          name="department" 
                          label="受理部门" 
                          rules={[{ required: true, message: '请选择部门' }]}
                        >
                          <Select placeholder="请选择受理部门">
                            <Option value="行政审批局">行政审批局</Option>
                            <Option value="市场监管局">市场监管局</Option>
                            <Option value="税务局">税务局</Option>
                            <Option value="财政局">财政局</Option>
                            <Option value="商务局">商务局</Option>
                            <Option value="人社局">人社局</Option>
                          </Select>
                        </Form.Item>
                      </Col>
                    </Row>
                    
                    <Form.Item 
                      name="description" 
                      label="详细描述" 
                      rules={[{ required: true, message: '请输入详细描述' }]}
                    >
                      <TextArea 
                        placeholder="请详细描述您的问题或需求，以便我们更好地为您服务" 
                        rows={6} 
                        maxLength={500} 
                        showCount 
                      />
                    </Form.Item>
                    
                    <Form.Item 
                      name="attachments" 
                      label="附件上传"
                    >
                      <Upload listType="picture">
                        <Button icon={<UploadOutlined />}>上传附件</Button>
                      </Upload>
                      <div className="upload-hint">支持PNG、JPG、PDF等格式，单个文件不超过10MB</div>
                    </Form.Item>
                    
                    <Form.Item 
                      name="priority" 
                      label="紧急程度"
                    >
                      <Select defaultValue="normal">
                        <Option value="high">紧急</Option>
                        <Option value="normal">普通</Option>
                        <Option value="low">低</Option>
                      </Select>
                    </Form.Item>
                    
                    <Form.Item className="form-actions">
                      <Button type="primary" htmlType="submit" size="large">
                        提交工单
                      </Button>
                      <Button size="large" style={{ marginLeft: 16 }} onClick={() => form.resetFields()}>
                        重置
                      </Button>
                    </Form.Item>
                  </Form>
                </div>
              </TabPane>
              <TabPane tab={<Badge count={mockTickets.filter(t => t.status !== 'done').length} offset={[10, 0]}>工单管理</Badge>} key="manage">
                <div className="ticket-manager">
                  <div className="ticket-filter">
                    <Input.Search
                      placeholder="搜索工单"
                      allowClear
                      prefix={<SearchOutlined />}
                      style={{ width: 200, marginRight: 16 }}
                    />
                    <Select defaultValue="all" style={{ width: 120, marginRight: 16 }}>
                      <Option value="all">全部状态</Option>
                      <Option value="pending">待受理</Option>
                      <Option value="processing">处理中</Option>
                      <Option value="done">已办结</Option>
                    </Select>
                    <Select defaultValue="all" style={{ width: 120 }}>
                      <Option value="all">全部类型</Option>
                      <Option value="咨询服务">咨询服务</Option>
                      <Option value="问题反馈">问题反馈</Option>
                      <Option value="政策咨询">政策咨询</Option>
                      <Option value="建议投诉">建议投诉</Option>
                    </Select>
                  </div>
                  
                  <div className="ticket-list-container">
                    <List
                      className="ticket-list"
                      itemLayout="horizontal"
                      dataSource={mockTickets}
                      renderItem={item => (
                        <List.Item 
                          onClick={() => setSelectedTicket(item)}
                          className={selectedTicket?.id === item.id ? 'ticket-item-active' : ''}
                        >
                          <div className="ticket-item">
                            <div className="ticket-item-header">
                              <div className="ticket-item-id">{item.id}</div>
                              <div className="ticket-item-time">{item.createTime.split(' ')[0]}</div>
                            </div>
                            <div className="ticket-item-title">{item.title}</div>
                            <div className="ticket-item-footer">
                              <div className="ticket-item-type">
                                <Tag>{item.type}</Tag>
                                {item.priority === 'high' && <Tag color="error">紧急</Tag>}
                              </div>
                              {getStatusTag(item.status)}
                            </div>
                          </div>
                        </List.Item>
                      )}
                    />
                  </div>
                  
                  <div className="ticket-detail-container">
                    {renderTicketDetail()}
                  </div>
                </div>
              </TabPane>
            </Tabs>
          </Card>
        </Col>
        
        <Col xs={24} md={8}>
          <Card 
            title={
              <div className="policy-card-title">
                <span>政策智能助手</span>
                <Tag color="#108ee9" style={{ marginLeft: 8 }}>智能推荐</Tag>
              </div>
            } 
            className="service-card policy-card"
          >
            <div className="policy-search">
              <Input.Search
                placeholder="搜索政策"
                allowClear
                enterButton="搜索"
              />
            </div>
            
            <Tabs defaultActiveKey="recommend">
              <TabPane tab="推荐政策" key="recommend">
                <List
                  className="policy-list"
                  itemLayout="vertical"
                  dataSource={mockPolicies.slice(0, 3)}
                  renderItem={item => (
                    <List.Item className="policy-item">
                      <div className="policy-header">
                        <div className="policy-title">{item.title}</div>
                        <div className="policy-match">
                          <Badge 
                            count={`匹配度 ${item.match}%`} 
                            style={{ 
                              backgroundColor: item.match > 90 ? '#52c41a' : 
                                              item.match > 70 ? '#1890ff' : '#faad14'
                            }} 
                          />
                        </div>
                      </div>
                      <div className="policy-meta">
                        <span className="policy-department">{item.department}</span>
                        <span className="policy-date">{item.publishDate}</span>
                      </div>
                      <div className="policy-tags">
                        {item.tags.map((tag, index) => (
                          <Tag key={index} color="blue">{tag}</Tag>
                        ))}
                      </div>
                      <div className="policy-abstract">{item.abstract}</div>
                      <div className="policy-actions">
                        <Button type="link">查看详情</Button>
                        <Button type="link">咨询申请</Button>
                      </div>
                    </List.Item>
                  )}
                />
              </TabPane>
              <TabPane tab="常见问题" key="faq">
                <List
                  className="faq-list"
                  itemLayout="vertical"
                  split={false}
                  dataSource={[
                    { question: '如何申请营业执照?', answer: '可以通过市场监管局网上服务大厅或实体大厅申请营业执照，所需材料包括：法定代表人身份证、公司章程、住所证明等。' },
                    { question: '企业变更登记需要什么材料?', answer: '企业变更登记需要提供变更申请书、企业法人营业执照正副本、变更相关证明材料等。具体以当地市场监管部门要求为准。' },
                    { question: '税务申报流程是怎样的?', answer: '企业可通过电子税务局或前往实体办税服务厅进行申报，按月（季）填报相关税种的纳税申报表，并按规定缴纳税款。' },
                  ]}
                  renderItem={item => (
                    <List.Item className="faq-item">
                      <div className="faq-question">
                        <Avatar size="small" icon={<RobotOutlined />} className="question-icon" />
                        <span>{item.question}</span>
                      </div>
                      <div className="faq-answer">
                        <Avatar size="small" className="answer-icon">A</Avatar>
                        <p>{item.answer}</p>
                      </div>
                    </List.Item>
                  )}
                />
                <div className="view-more">
                  <Button type="link">查看更多问题</Button>
                </div>
              </TabPane>
            </Tabs>
            
            <Divider />
            
            <div className="chat-assistant">
              <div className="chat-header">
                <RobotOutlined /> 智能咨询助手
              </div>
              <div className="chat-body">
                <div className="chat-message assistant">
                  <Avatar size="small" icon={<RobotOutlined />} />
                  <div className="message-content">
                    <div className="message-bubble">
                      您好！我是智能助手，有什么可以帮您解答的问题吗？
                    </div>
                    <div className="message-time">10:30</div>
                  </div>
                </div>
                <div className="chat-input">
                  <Input.Search
                    placeholder="输入您的问题..."
                    enterButton="发送"
                    size="large"
                  />
                </div>
              </div>
            </div>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default BusinessServiceHall; 